import { axiosInstance as axios } from "@/core/services/api.client";

const prefix = "api/v1/tenant/event";

export default {
  queryEventsList: async (criteria?: any) =>
    (await axios.get(prefix, { params: criteria })).data,

  createEvent: async (formData: any) =>
    (await axios.post(prefix, formData)).data,

  queryEventById: async (id: number) =>
    (await axios.get(`${prefix}/${id}`)).data,

  updateEvent: async (id: number, formData: any) =>
    (await axios.put(`${prefix}/${id}`, formData)).data,

  publishEvent: async (id: number) =>
    (await axios.put(`${prefix}/${id}/publish`)).data,

  unpublishEvent: async (id: number) =>
    (await axios.put(`${prefix}/${id}/close`)).data,

  updateEventLanguage: async (id: number, lang: string, formData: any) =>
    (await axios.put(`${prefix}/${id}/lang/${lang}`, formData)).data,

  uploadImage: async (formData: any) =>
    (await axios.post("api/v1/tenant/upload/public?type=public", formData))
      .data,
};
